export const FOREVER_PASS_GUARANTEE_EXPLANATION =
    'We are as invested as you are in your success. Our forever pass guarantee ensures that you only ever pay for the same course once. If you don’t take or pass the exam on your first attempt, just email us and we’ll restore your access at no additional cost. '
